module.exports = __webpack_public_path__ + "mq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mq.svg
// module id = 702
// module chunks = 0